const resources = {
    relatedContentLabel: 'Related Content',
    exploreMoreLabel: 'Explore More'
};

module.exports = function getResource(label) {
    return resources[label];
};
